
// Selectors
export const selectCurrentPackage = (state) =>
  state.pricing.currentPackage
